import { NDFL3DefaultLogic } from './NDFL3DefaultLogic';

class NDFL3YearLogic2015 extends NDFL3DefaultLogic {
  name() {
    return '2015';
  }

  showLossesTransferDeduction() {
    return false;
  }

  showSumOfPreviousPeriods() {
    return false;
  }

  showKikNumber() {
    return false;
  }

  showDetermProcedureKIK() {
    return false;
  }

  /**
   * Отображается только если в поле «Предоставить налоговый вычет» выбрано значение
   *  «509 - Вычет из суммы доходов, получ. работниками в натурал. форме от с/х товаропроиз.».
   * @param {number} [taxDeductionCode]
   * @returns {boolean}
   */
  showNumWorkedMonths(taxDeductionCode) {
    return taxDeductionCode === 509;
  }

  getPFIorFISS() {
    return 'ФИСС';
  }

  isComplexDwellingRegDateName() {
    return true;
  }

  showDrugsExpenses() {
    return false;
  }
}

export default NDFL3YearLogic2015;
